import ConsignorHome from './ConsignorHome';

export default ConsignorHome;
